<!--Mobile View-->
<div class="wrapper container-fluid" *ngIf="isMobileTheme">
    <div *ngIf="isCBOL" id="citilmBrand"></div>
    <div class="col-xs-9 padding-0">
        <ng-container *ngIf="(step =='postLogin' || step =='disclosure') && !hideHeaderFooter && !hideNav">     
            <!-- <modern-mobile-navigation [showLanguageSwitch]="isSpanishEnabledIBD && !isDisclosures" [isMobileTheme]="isMobileTheme" [menuItems]="nav"></modern-mobile-navigation> -->
            <modern-mobile-navigation [showLanguageSwitch]="isSpanishEnabledIBD" [isMobileTheme]="isMobileTheme" [menuItems]="nav"></modern-mobile-navigation>
        </ng-container>
    </div>
    <div>
        <ng-container *ngIf="step == 'login' && !hideHeaderFooter">
            <nxi-google-analytics></nxi-google-analytics>
            <modern-theme-header *ngIf="!hideHeader" [showLanguageSwitch]="isSpanishEnabledIBD"></modern-theme-header>
        </ng-container>
        <main class="fw-MainContent no-border padding-left-0 padding-right-0">
            <ng-container *ngIf="(step =='postLogin' || step =='disclosure') && !hideHeaderFooter">
                <nxi-google-analytics></nxi-google-analytics>
                <modern-theme-header *ngIf="!hideHeader" [isLoggedIn]="isLoggedIn" [showLanguageSwitch]="isSpanishEnabledIBD"
					[hideLogoutButton]="hideLogoutButton" [hideQuickQuote]="hideQuickQuote" [hideNavigation]="hideNav"
                    [showHeaderActions]="showHeaderActions" [logoShouldNavigateAway]="logoShouldNavigateAway">
				</modern-theme-header>
            </ng-container>
            <router-outlet></router-outlet>
            <modern-theme-footer class="fw-FooterContainer" *ngIf="!hideHeaderFooter && !hideMobileFooter"></modern-theme-footer>
        </main>
    </div>
    <div *ngIf="isCBOL" id="citilmFooter"></div>
</div>

<!-- Tablet View -->
<div class="wrapper container-fluid" *ngIf="isTabletTheme">
    <div *ngIf="isCBOL" id="citilmBrand"></div>
    <div class="col-xs-3">
        <ng-container *ngIf="(step =='postLogin' || step =='disclosure') && !hideHeaderFooter && !hideNav">
            <!-- <modern-mobile-navigation [showLanguageSwitch]="isSpanishEnabledIBD && !isDisclosures" [isTabletTheme]="isTabletTheme" [menuItems]="nav"></modern-mobile-navigation> -->
            <modern-mobile-navigation [showLanguageSwitch]="isSpanishEnabledIBD" [isTabletTheme]="isTabletTheme" [menuItems]="nav"></modern-mobile-navigation>
        </ng-container>
    </div>
    <div>
        <ng-container *ngIf="step == 'login' && !hideHeaderFooter">
            <nxi-google-analytics></nxi-google-analytics>
            <modern-theme-header *ngIf="!hideHeader" [showLanguageSwitch]="isSpanishEnabledIBD" ></modern-theme-header>
        </ng-container>
        <main class="fw-MainContent no-border padding-left-0 padding-right-0">
            <ng-container *ngIf="(step =='postLogin' || step =='disclosure') &&!hideHeaderFooter">
                <nxi-google-analytics></nxi-google-analytics>
                <modern-theme-header *ngIf="!hideHeader"    [isLoggedIn]="isLoggedIn" [showLanguageSwitch]="isSpanishEnabledIBD"
					[hideLogoutButton]="hideLogoutButton" [hideQuickQuote]="hideQuickQuote" [hideNavigation]="hideNav"
                    [showHeaderActions]="showHeaderActions" [logoShouldNavigateAway]="logoShouldNavigateAway">
				</modern-theme-header>
            </ng-container>
            <router-outlet></router-outlet>
            <modern-theme-footer class="fw-FooterContainer" *ngIf="!hideHeaderFooter && !hideMobileFooter"></modern-theme-footer>
        </main>
    </div>
    <div *ngIf="isCBOL" id="citilmFooter"></div>
</div>

<!-- Desktop View -->
<div id="main-container" class="wrapper container-fluid" *ngIf="!isMobileTheme && !isTabletTheme">
    <div *ngIf="isCBOL" id="citilmBrand"></div>
    <ng-container *ngIf="step == 'login'">
        <nxi-google-analytics></nxi-google-analytics>
        <modern-theme-header *ngIf="!hideHeader" [showLanguageSwitch]="isSpanishEnabledIBD" ></modern-theme-header>
    </ng-container>
    <ng-container *ngIf="step == 'disclosure'">
        <nxi-google-analytics></nxi-google-analytics>
        <modern-theme-header *ngIf="!hideHeader" [showLanguageSwitch]="isSpanishEnabledIBD"  ></modern-theme-header>
        <nav class="fw-NavigationContainer" *ngIf="!hideNav">
            <modern-theme-navigation [menuItems]="nav"></modern-theme-navigation>
            <modern-theme-secondlevel-navigation *ngIf="!hideSecondLevelNav"></modern-theme-secondlevel-navigation>
        </nav>
    </ng-container>
    <ng-container *ngIf="step == 'postLogin' && !hideHeaderFooter">
        <nxi-google-analytics></nxi-google-analytics>
        <mcv-header *ngIf="isAdvisor"></mcv-header>
        <modern-theme-header *ngIf="!hideHeader"    [isLoggedIn]="isLoggedIn" [showLanguageSwitch]="isSpanishEnabledIBD"
			[hideLogoutButton]="hideLogoutButton" [hideQuickQuote]="hideQuickQuote" [showHeaderActions]="showHeaderActions"
            [logoShouldNavigateAway]="logoShouldNavigateAway">
		</modern-theme-header>
        <nav class="fw-NavigationContainer" *ngIf="!hideNav">
            <modern-theme-navigation [menuItems]="nav"></modern-theme-navigation>
			<modern-theme-secondlevel-navigation *ngIf="!hideSecondLevelNav"></modern-theme-secondlevel-navigation>
        </nav>
    </ng-container>
    <ng-container *ngIf="step == 'postLogin' && hideHeaderFooter  && isBackNavigationEnabled">
        <back-navigation></back-navigation>
    </ng-container>
    <main class="fw-MainContent" id="maincontent">
        <router-outlet></router-outlet>
    </main>
    <modern-theme-footer class="fw-FooterContainer" *ngIf="!hideFooter && !hideHeaderFooter"></modern-theme-footer>
    <div *ngIf="isCBOL" id="citilmFooter"></div>
</div>